import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import useSettlementAmountSection from "../../hooks/useSettlementAmountSection";
import { useSettlementStore } from "../../store/settlementStore";
import { SETTLEMENT_STYLES } from "../../style/styles";
import SettlementActionButtons from "../common/SettlementActionButtons";
import SettlementDateField from "../common/SettlementDateField";
import SettlementTextField from "../common/SettlementTextField";

import SettlementStatusIndicator from "./SettlementStatusIndicator";

export default function SettlementAmountSection() {
  const caseDetail = useSettlementStore((state) => state.caseDetail);
  const {
    formValues,
    isDirty,
    isEditing,
    isAmountEditing,
    isSaving,
    hasCheck,
    showStatus,
    canEditCaseSettlement,
    handleBeginEdit,
    handleBeginAmountEdit,
    handleClearAmount,
    handleFieldChange,
    handleCancel,
    handleSave,
  } = useSettlementAmountSection({ caseDetail });

  return (
    <section
      className="flex min-h-[200px] flex-col rounded-[12px] p-4 shadow-sm"
      style={SETTLEMENT_STYLES.sectionCard}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <Svg
            name={SvgEnum.HisDollarSign}
            color={SETTLEMENT_STYLES.sectionIconColor}
            sx={SETTLEMENT_STYLES.sectionIcon}
          />
          <h3 className="text-lg font-semibold" style={SETTLEMENT_STYLES.sectionTitle}>
            Settlement
          </h3>
        </div>
        <SettlementStatusIndicator
          isComplete={hasCheck}
          visible={showStatus}
        />
      </div>

      <div className="mt-4 w-full">
        <SettlementTextField
          label="Settlement Amount"
          value={formValues.actualTotalSettlementAmount}
          onChange={(event) => handleFieldChange("actualTotalSettlementAmount", event.target.value)}
          placeholder="Enter settlement amount"
          startAdornment="$"
          isEditable={isAmountEditing}
          showEditIcon={canEditCaseSettlement && !isAmountEditing}
          showClearIcon={canEditCaseSettlement && isAmountEditing}
          onEditClick={handleBeginAmountEdit}
          onDisplayClick={handleBeginAmountEdit}
          onClear={handleClearAmount}
          canEdit={canEditCaseSettlement}
        />
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
        <SettlementDateField
          label="Settlement Date"
          value={formValues.insuranceSettlementDate}
          onOpen={handleBeginEdit}
          onFocus={handleBeginEdit}
          onChange={(newValue) => handleFieldChange("insuranceSettlementDate", newValue)}
          disabled={!canEditCaseSettlement}
        />
        <SettlementDateField
          label="Finalized Date"
          value={formValues.settlementFinalizedOn}
          onOpen={handleBeginEdit}
          onFocus={handleBeginEdit}
          onChange={(newValue) => handleFieldChange("settlementFinalizedOn", newValue)}
          disabled={!canEditCaseSettlement}
        />
      </div>

      {isEditing && canEditCaseSettlement ? (
        <div className="mt-4 flex">
          <SettlementActionButtons
            disableSave={isSaving || !isDirty}
            handleOnClickSaveButton={handleSave}
            disableCancel={isSaving}
            handleOnClickCancelBtn={handleCancel}
          />
        </div>
      ) : null}
    </section>
  );
}
